import React from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import AccountBalanceWalletRoundedIcon from "@mui/icons-material/AccountBalanceWalletRounded";
import PaymentsRoundedIcon from "@mui/icons-material/PaymentsRounded";
import RepeatRoundedIcon from "@mui/icons-material/RepeatRounded";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import { money, surfaceSx } from "./ownerCenterUi";

function MoneyCard({ icon: Icon, label, value, hint, tone = "text.primary" }) {
  return (
    <Box sx={{ minWidth: 0, p: { xs: 1, sm: 1.25 }, borderRadius: 2.5, bgcolor: "action.hover" }}>
      <Stack direction="row" spacing={.7} alignItems="center">
        <Icon sx={{ fontSize: 20, color: tone }} />
        <Typography sx={{ color: "text.secondary", fontWeight: 900, fontSize: 11.5 }}>{label}</Typography>
      </Stack>
      <Typography noWrap sx={{ mt: .65, color: tone, fontWeight: 1000, fontSize: { xs: 20, sm: 24, md: 27 }, letterSpacing: "-.04em" }}>{value}</Typography>
      {hint ? <Typography noWrap sx={{ mt: .2, color: "text.secondary", fontWeight: 700, fontSize: 10.5 }}>{hint}</Typography> : null}
    </Box>
  );
}

export default function OwnerMoneyRealityStrip({ center, assistant, currency = "ARS", onCurrencyChange, onOpenFinance }) {
  const available = Number(center?.finance?.totalsByCurrency?.[currency] || 0);
  const outstanding = Number(center?.commercial?.outstandingByCurrency?.[currency] || 0);
  const recurringFloor = Number(assistant?.economy?.monthlyRecurringFloor || 0);
  const currencies = [...new Set([...(assistant?.currencies || []), currency])].filter(Boolean).slice(0, 3);

  return (
    <Box data-owner-jarvis-section="today-money" sx={{ ...surfaceSx, p: { xs: 1.2, sm: 1.45 } }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
        <Typography sx={{ fontWeight: 1000, fontSize: { xs: 16, sm: 18 } }}>Dinero</Typography>
        <Stack direction="row" spacing={.25} alignItems="center">
          {currencies.map((item) => (
            <Button key={item} size="small" variant={item === currency ? "contained" : "text"} onClick={() => onCurrencyChange?.(item)} sx={{ minWidth: 38, px: .6, borderRadius: 1.8, fontWeight: 1000 }}>{item}</Button>
          ))}
          <Button size="small" endIcon={<ArrowForwardRoundedIcon />} onClick={onOpenFinance} sx={{ minWidth: 0, px: .7, textTransform: "none", fontWeight: 950 }}>Abrir</Button>
        </Stack>
      </Stack>

      <Box sx={{ display: "grid", gridTemplateColumns: "repeat(3,minmax(0,1fr))", gap: { xs: .6, sm: .8 }, mt: 1 }}>
        <MoneyCard icon={AccountBalanceWalletRoundedIcon} label="Ahora" value={money(available, currency)} />
        <MoneyCard icon={PaymentsRoundedIcon} label="Cobrar" value={money(outstanding, currency)} tone={outstanding > 0 ? "warning.main" : "text.primary"} />
        <MoneyCard icon={RepeatRoundedIcon} label="Mensual" value={money(recurringFloor, currency)} hint="base recurrente" />
      </Box>
    </Box>
  );
}
